import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'src/utils/Hooks';
import { shutdown } from '@intercom/messenger-js-sdk';
import queryClient from 'src/queryClient';
import * as appOperations from 'src/store/modules/app/operations';
import { authOperations } from 'src/store/modules/auth';
import { trackLogOut } from 'src/utils/mixpanel';
import { amplifySignOut } from 'src/utils/auth';
import { parseQueryString } from 'src/utils/browser';
import queryString from 'query-string';
import { saveSSOReferrer } from 'src/utils/sso';

const SignOut = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    // Get current query parameters to preserve referrer
    const currentQueryParams = parseQueryString();
    const referrer = currentQueryParams.referrer;
    const redirectPath = referrer ? `/sign_in?${queryString.stringify({ referrer })}` : '/sign_in';

    const performLogout = async () => {
      try {
        saveSSOReferrer();

        // Perform logout operations
        shutdown();
        await dispatch(authOperations.logOut());
        trackLogOut();
        localStorage.removeItem('x-sl-signin-user-email');
        await amplifySignOut();
        dispatch(appOperations.fetchConfig());
        queryClient.clear();
        dispatch(appOperations.clearReduxState());

        history.push(redirectPath);
      } catch (error) {
        console.error('Error signing out:', error);
        // Still redirect to sign_in even if there's an error
        history.push(redirectPath);
      }
    };

    performLogout();
  }, [dispatch, history]);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px',
        fontFamily: 'Geist, sans-serif'
      }}
    >
      Signing out...
    </div>
  );
};

export default SignOut;
